import AppInput from '@/components/common/AppInput';
import ToolbarIcons from '@/icons/toolbar';
import { useTranslations } from 'next-intl';
import React, {
  ChangeEvent,
  KeyboardEvent,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
// import { LayoutContext } from '@/context/LayoutContext';

type AppSearchType = {
  callbackSearch?: (x: string) => void;
  callBackonChange?: (x: string) => void;
  callBackonChangeSuggest?: (x?: string | undefined) => void;
  className?: string;
  // inputclassname?: string;
  wrapper?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  children?: ReactNode;
  initialValue?: string | undefined;
  ref?: any;
  iconFill?: string;
  placeholder?: string;
  affix?: ReactNode;
  showAffix?: boolean;
  prefix?: ReactNode;
};
export default function AppSearch({
  callbackSearch,
  className = '',
  // inputclassname = '',
  wrapper = '',
  callBackonChange,
  callBackonChangeSuggest,
  onFocus,
  onBlur,
  children = null,
  initialValue = '',
  iconFill,
  ref,
  placeholder,
  affix,
  showAffix = true,
  prefix,
}: AppSearchType) {
  const t = useTranslations('common');

  const [searchInput, setSearchInput] = useState<string | undefined>(initialValue);
  const [timerValue, setTimerValue] = useState(3000);

  console.log('value==', initialValue);
  useEffect(() => {
    setSearchInput(initialValue);
  }, [initialValue]);

  const searchFunction = (e: ChangeEvent<HTMLInputElement>) => {
    // let inputValue = e.target.value.replace(/\//g, '');
    let inputValue = e.target.value;
    setSearchInput(inputValue);

    // if (callBackonChange) {
    //   callBackonChange(inputValue);
    // }
    // callbackSearch && callbackSearch(inputValue);
  };
  useEffect(() => {
    let time = 2000;
    setTimerValue(time);
    callBackonChangeSuggest && searchInput && callBackonChangeSuggest(searchInput);
    if (searchInput?.trim().length != 0) {
      var x = setInterval(function () {
        time = time - 1000;

        if (time == 0) {
          clearInterval(x);
          setTimerValue(time);
        }
      }, 1000);
    } else {
    }
  }, [searchInput]);
  useEffect(() => {
    if (timerValue == 0) {
      callBackonChange && searchInput && callBackonChange(searchInput);
    }
  }, [timerValue]);
  const pressKey = (e: KeyboardEvent<HTMLElement>) => {
    if (e.keyCode === 13) {
      callbackSearch && searchInput && callbackSearch(searchInput);
    }
  };
  return (
    <AppInput
      showAffix={showAffix}
      prefix={
        <>
          {searchInput ? (
            <ToolbarIcons.CloseCircleIcon
              width={'16px'}
              height={'16px'}
              fill="var(--paper)"
              onClick={() => {
                setSearchInput('');

                // if (callBackonChange) {
                callBackonChange && callBackonChange('');
                // } else {
                callbackSearch && callbackSearch('');
                // }
              }}
            />
          ) : (
            <MainIcons.searchIcon
              fill={iconFill}
              // onClick={() => {
              //   callbackSearch && callbackSearch(searchInput);
              // }}
              width={'18px'}
              height={'18px'}
            />
          )}
        </>
      }
      affix={affix}
      extraWrapperClass={`${styles.wrapper}  ${className}`}
      // inputclassname={inputclassname}
      // wrapper={wrapper}
      affixWrapper={`${styles.affixWrapper} `}
      onClickAffix={() => {
        callbackSearch && searchInput && callbackSearch(searchInput);
      }}
      placeholder={placeholder ? placeholder : t('search')}
      onChange={(e: any) => {
        searchFunction(e);
      }}
      value={searchInput}
      onKeyDown={(e: any) => {
        pressKey(e);
      }}
      onFocus={onFocus}
      onClickInput={onFocus}
      showRemoveIcon={false}
      child={children ? children : null}
      onBlur={onBlur}
      wrapper={`${styles.wrapperInput} ${wrapper}`}
      ref={ref}
    ></AppInput>
  );
}
